<template>
  <div>
    <label class="switch">
      <input type="checkbox" checked v-model="isDark" />
      <span class="slider round"></span>
    </label>
  </div>
</template>
<script>
export default {
  data: () => ({
    isDark: "",
  }),
  mounted() {
    this.isDark = this.$vuetify.theme.dark;
  },
  watch: {
    isDark(nv) {
      this.$emit("changeTheme", nv);
    },
  },
  methods: {},
};
</script>
<style>
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 30px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  background: url("../../assets/sun.svg");
  background-color: white;
  background-repeat: no-repeat;
  background-size: 13px;
  background-position: center;
}
input:checked + .slider {
  background-color: #121212;
}
input:focus + .slider {
  box-shadow: 0 0 1px #121212;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  background: url("../../assets/moon.svg");
  background-repeat: no-repeat;
  background-size: 15px;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
</style>
